<template>
  <div ref="boxwrap" class="box" @click="disnoneFn">
    <div :id="id" class="videoBox"></div>
    <div class="mask" @click="togglePlay" :style="{ 'display': play ? 'none' : 'block' }">
      <div class="iconbox jiebox" :style="list.imageUrl ? { backgroundImage: `url(${list.imageUrl})` } : {}">
        <img src="../../assets/image/1.Base基础／3.Icon图标／操作／播放@2x.png" alt />
        <!-- <p style="font-family: PingFangSC, PingFang SC;color: #5D7C9E;">点击播放视频</p> -->
      </div>
    </div>
    <div class="mask" :style="{ 'display': play1 ? 'none' : 'block' }">
      <div class="iconbox">
        <img src="../../assets/image/报错@2x.png" alt />
        <p 
          style="font-family: AlibabaPuHuiTi_2_55_Regular;font-size: .8125rem;color: #5D7C9E;"
        >设备报错，请重新连接</p>
        <button
          @click="chongClick"
          style="margin-top: .3125rem; font-size: .875rem; width: 3.75rem;height: 1.875rem;color: #fff; background: #2390F4;border-radius: .25rem; border: 0px;"
        >重连</button>
      </div>
    </div>
    <div class="kong" :style="`display:${this.disno};bottom:${kbottom};height:${kheight};`">
      <div class="zhi">
        <div class="left">
          <el-tooltip effect="dark" :content="play ? '正在播放' : '停止'">
            <i
              :class="play ? 'el-icon-video-pause' : 'el-icon-video-play'"
              @click="togglePlay"
              :style="`font-size: ${fontsize};`"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="视频截图">
            <i class="el-icon-camera" @click="isCapturePicture" :style="`font-size: ${fontsize};`"></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="视频录制" v-show="save==true">
            <i class="el-icon-video-camera" @click="isstartSave" :style="`font-size: ${fontsize};`"></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="停止录制" v-show="save==false">
            <i
              class="el-icon-video-camera-solid"
              @click="isstopSave"
              :style="`font-size: ${fontsize};`"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" :content="enableZ ? '电子放大-已开启' : '电子放大-已关闭'">
            <i
              :class="enableZ ? 'el-icon-zoom-out' : 'el-icon-zoom-in'"
              @click="toggleZoom"
              :style="`font-size: ${fontsize};`"
            ></i>
          </el-tooltip>
        </div>
        <div class="right">
          <el-tooltip effect="dark" content="全屏">
            <i class="el-icon-full-screen" @click="isFullScreen" :style="`font-size: ${fontsize};`"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="tou" v-if="showBottom&&this.disno==='block'" :style="`top:${kbottom};height:${kheight};`">
      <div class="zhi">
        <div class="left">
          <i class="iconfont icon-shipin"></i>
          {{ list.ysChannelName }}
        </div>
        <div class="right">
          <el-tooltip v-if="isShowAdd"  effect="dark" content="收藏">
            <i
              class="el-icon-star-off"
              @click="addshoucang(list)"
              :style="`font-size: ${fontsize};`"
            ></i>
          </el-tooltip>
          <el-tooltip effect="dark" content="清除">
            <i
              class="el-icon-s-open"
              @click="delhdarr(list)"
              :style="`font-size: ${fontsize};color:#fff`"
            ></i>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var flage = 1;
import EZUIKit from "ezuikit-js";
export default {
  props: {
    list: {
      default: {}
    },
    url: {
      default: ""
    },
    imgUrl:{
      default: ""
    },
    height: {
      default: 0
    },
    width: {
      default: 0
    },
    id: {
      default: ""
    },
    kbottom: {
      default: ""
    },
    kheight: {
      default: ""
    },
    fontsize: {
      default: "20px"
    },
    token: {
      default: ""
    },
    showBottom:{
      default:true

    },
    isShowAdd:{
      default:true
    }
  },
  data() {
    return {
      UIKitDEMO: null,
      disno: "none",
      play: false, //默认停止播放
      play1: true, //错误
      save: true,
      enableZ: false, //默认关闭电子放大
      isStop: false ,//主动停止
    };
  },
  mounted() {
   
    this.getvido();
    
    this.getsetPoster();
  },
  watch: {
    // url: function(newUrl, oldUrl) {
    //   this.getvido(); // 重新加载视频
    //   this.play = false;
    // }
  },

  beforeDestroy() {
    if (this.play) this.UIKitDEMO.stop();
  },
  methods: {
    getvido() {
      this.UIKitDEMO  =null;
      let box=this.$refs.boxwrap
      let width = box.clientWidth;
      let height = box.clientHeight;
      console.log(width,height,'kuangaoi')
      this.UIKitDEMO = new EZUIKit.EZUIKitPlayer({
        id: this.id,
        url: this.url,
        accessToken: this.token,
        width:width,
        height: height,
        autoplay: this.$store.state.isAuto,
        // useHardDev: false,
        // template: "security", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        // audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
        // 捕获错误回调
        handleError: e => {
          console.log(e,'失败毁掉')
       
          if(this.isStop ){//如果是主动暂停
            this.play1 = true;
          }
          this.play1 = false;
          this.play = false;
        },
        handleSuccess:e=>{
          this.play1 = true;
          this.play = true;
        }
      });
    },
    async getsetPoster() {
      console.log(this.list, 145);
      let obj = {
        accessToken: this.token,
        deviceSerial: "C58496898"
      };
      //     this.UIKitDEMO.setPoster(this.url)
      //      axios({
      //       url:'https://open.ys7.com/api/open/cloud/v1/capture/save',
      //  method:"post",
      //  params:obj
      //      }).then((res)=>{
      // console.log(res,159)
      //      })
    },
    chongClick() {
      this.play1 = true;
      this.play = true;
      this?.UIKitDEMO
            ?.changePlayUrl({
              url: this.url,
              accessToken: this.token,
            })
            .then(() => {
              //qf 20240925 自动截图上传的逻辑先屏蔽
              // setTimeout(() => {
              //   if (!this.isRec) this.capturePicture();
              // }, 1000);

            });
    },
    disnoneFn() {
      if (this.disno == "block") {
        this.disno = "none";
      } else {
        this.disno = "block";
      }
    },
    // 开启/关闭 电子放大
    toggleZoom() {
      if (!this.UIKitDEMO || !this.play) return;
      switch (this.enableZ) {
        case true:
          this.UIKitDEMO.closeZoom();
          this.enableZ = false;
          break;
        case false:
          this.UIKitDEMO.enableZoom();
          this.enableZ = true;
          break;
        default:
          break;
      }
    },
    delhdarr(list){
      this?.UIKitDEMO?.stop();
      this.$emit('delobj', list);
    },
    // 播放/停止 监控
    togglePlay() {
      if (!this.UIKitDEMO) return;
      switch (this.play) {
        case true:
          this.UIKitDEMO.stop();
          this.play = false;
          this.isStop= true
          break;
        case false:
        this?.UIKitDEMO
            ?.changePlayUrl({
              url: this.url,
              accessToken: this.token,
            })
            this.isStop = false
          this.play = true;
          break;
        default:
          break;
      }
    },
    // 视频截图
    isCapturePicture() {
      if (!this.UIKitDEMO || !this.play) return;
      this.UIKitDEMO.capturePicture();
    },
    // 视频录制
    isstartSave() {
      console.log(this.save);
      if (!this.UIKitDEMO || this.save == true) {
        let date = new Date().getTime();
        this.UIKitDEMO.startSave(date);
        this.save = false;
      }
    },
    // 停止录制
    isstopSave() {
      console.log(this.save);
      if (!this.UIKitDEMO || this.save == false) {
        this.UIKitDEMO.stopSave();
        this.save = true;
      }
    },
    // 全屏
    isFullScreen() {
      if (!this.UIKitDEMO || !this.play) return;
      this.UIKitDEMO.fullScreen();
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  .videoBox {
    width: 100%;
    height: 98%;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #16385e;
    z-index: 9999999999;
    color: #fff;
    .jiebox {
      background: url("../../assets/image/1716773712022.jpg") no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
    }
    
    .iconbox {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 15%;
        margin-bottom: 2%;
      }
      p {
        font-size: 16px;
      }
    }
  }

  .kong {
    position: absolute;
    left: 0;
    // bottom: 40px;
    width: 100%;
    height: 2.5rem;
    background: rgb(0, 0, 0, 0.5);
    .zhi {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;

      .left {
        i {
          margin-right: 10px;
        }
      }
      i {
        vertical-align: middle;
        color: #fff;
      }
    }
  }
  .tou {
    position: absolute;
    left: 0;
    // bottom: 40px;
    width: 100%;
    height: 2.5rem;
    color: #fff;
    background: rgb(0, 0, 0, 0.5);
    .zhi {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      .left {
        i {
          margin-right: 10px;
        }
      }
      .right {
        i {
          margin-right: 10px;
        }
      }

      i {
        vertical-align: middle;
        color: #fff;
      }
    }
  }
}
</style>
